<template>
  <div class="py-10 pb-20 min-h-screen bg-white">
    <Sidebar></Sidebar>
    <Header>{{ user.name }} {{ user.surname }}</Header>
    <div class="bg-pink pb-8 pt-8 px-10 text-center block">
      <div class="container mx-auto">
        <div class="flex items-baseline">
          <div class="relative flex-1">
            <img
              class="w-24 h-24 rounded-full border-4 align-middle z-3 relative "
              src="/img/user.png"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto my-auto">
      <div class="text-right mt-5 pr-4">
        <router-link
          :to="{name: 'ProfileEdit'}"
          replace
        ><i class="fas fa-edit text-grey"></i>
        </router-link>
      </div>
      <div class="px-4 pt-5">
        <p class="text-blue-dark">
          <b>{{$t('all.profile_data')}}</b>
        </p>

        <!-- CF -->
        <div class="flex">
          <div class="pt-4 flex-1">
            <p class="pb-2">
              <i class="text-xs">{{$t('all.common_name')}}</i><br>
              {{ user.name }}
            </p>
          </div>
          <div class="pt-4 flex-1">
            <p class="pb-2">
              <i class="text-xs">{{$t('all.common_last_name')}}</i><br>
              {{ user.surname }}
            </p>
          </div>
        </div>
        <!-- fine CF -->
        <!-- CF -->
        <div class="pt-4">
          <p class="pb-2">
            <i class="text-xs">{{$t('all.profile_fiscal_code')}}</i><br>
            {{ user.fiscal_code }}
          </p>
        </div>
        <!-- fine CF -->
        <!-- CF -->
        <div class="flex">
          <div
            class="pt-4 flex-1"
            v-if="user.phone"
          >
            <p class="pb-2">
              <i class="text-xs">{{$t('all.profile_phone')}}</i><br>
              {{ user.phone }}
            </p>
          </div>
          <!-- fine CF -->
          <!-- CF -->
          <div
            class="pt-4 flex-1"
            v-if="user.mobile"
          >
            <p class="pb-2">
              <i class="text-xs">
                {{chkUserInfo('tutor') ? $t('all.emergency_phone') : chkUserInfo('teacher') ? $t('all.profile_mobile') : ''}}
              </i><br>
              {{ user.mobile }}
            </p>
          </div>
        </div>
        <!-- fine CF -->
        <!-- CF -->
        <div class="flex pt-4">
          <div class="pt-4 flex-1">
            <p class="pb-2">
              <i>{{ $t('all.showReferences')}}</i>
            </p>
          </div>
          <div class="pt-4 flex-1">
            <p class="pb-2 pr-4 text-right">
              {{ user.show_contacts == 1 || user.show_contacts == true ? $t('all.yes') : $t('all.no')}}
            </p>
          </div>
        </div>
        <!-- CF -->
        <div class="flex pt-4">
          <div class="pt-4 flex-1">
            <p class="pb-2">
              <i>{{$t('all.language')}}: </i>
            </p>
          </div>
          <div class="pt-4 flex-1">
            <p
              class="pb-2 pr-4 text-right"
              v-if="lang === 'en'"
            >
              {{$t('all.english')}}
            </p>
            <p
              class="pb-2 pr-4 text-right"
              v-else-if="lang === 'it'"
            >
              {{$t('all.italian')}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { authService } from '@/services';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['id'],
  mounted() {
    // await this.getUserInfo();
    this.lang = this.$i18n.locale;
  },
  data() {
    return {
      lang: '',
    };
  },
  computed: {
    ...mapGetters({
      user: 'authentication/individual',
    }),
  },
  methods: {
    ...mapActions('authentication', ['getUserInfo']),
    chkUserInfo(role) {
      return authService.hasRole(role);
    },
  },
};
</script>
